import { isObjectEmpty } from '../utils'

const updateAnalyseData = (state, action) => {

  const defaultState = {
    accordionItemsWithCells: [],
    analyseProgressBar: {},
    bodyBorderShow: true,
    ltOffset: 0,
    textLanguage: '',
    autoTextLanguage: '',
    ignoreList: {},
    useBenchmark: 0,
    enabledBenchmarks: {},
    topAccordionOpen: '',
    modalAccordionOpen: '',
    allowListText: '',
    popUpData: '',
    aiMode: false,
    aiData: {},
    filter: {
      hix: false,
      clix: false,
      flesch: false,
      languageLevel: false,
      red: true,
      yellow: true,
      // by default green is filtered
      green: false,
      blue: true,
    },
    text: '',
    oldText: '',
    translatedText: '',
    termCatTexttone: '',
    result: {
      resultData: {},
      languageLevelDataWithChildren: {},
      localAnalyseResultData: {},
      aiLocalAnalyseResultData: {},
      resultTemplate: 0,
      benchmark: {},
    },
    popover: {
      nnSuggestions: {},
      popups: [],
      currentPopup: -1,
    },
    fileName: '',
    sanitize: {
      placeholdersAccessCode: '',
      originalState: null,
    },
    saveArchive: {
      folderId: 0,
      id: 0,
      version: '',
      tags: [],
      type: 'personal',
      name: ''
    }
  }

  if (state === undefined) {
    return defaultState
  }

  const nnSuggestions = { ...state.analyseData.popover.nnSuggestions }
  switch (action.type) {

    case 'ANALYSE_SET_SAVE_ARCHIVE':
      return {
        ...state.analyseData,
        saveArchive: action.payload,
      }

    case 'ANALYSE_CLEAR_SAVE_ARCHIVE':
      return {
        ...state.analyseData,
        saveArchive: defaultState.saveArchive,
      }

    case 'ANALYSE_UPDATE_NN_SUGGESTION':
      const updatedNNSuggestions = {
        ...nnSuggestions,
        [action.payload.mainText]: {
          ...nnSuggestions[action.payload.mainText],
          data: {
            ...nnSuggestions[action.payload.mainText].data,
            sequences: nnSuggestions[action.payload.mainText].data.sequences.map(
              (sequence, index) =>
                index === action.payload.index ? action.payload.text : sequence
            ),
          },
        },
      }
      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          nnSuggestions: updatedNNSuggestions
        },
      }

    case 'FETCH_NN_SUGGESTION_SUCCESS':
      // filtering
      const data = action.payload.suggestion?.data || {}
      const updatedSuggestions = {
        ...nnSuggestions,
        [action.payload.text]: {
          ...nnSuggestions[action.payload.text],
          data: {
            sequences: [],
            sequences_scores: []
          },
          loading: false,
          error: null
        }
      }

      if (!isObjectEmpty(data) && !isObjectEmpty(data['sequences'])) {
        for (let i = 0; i < data['sequences'].length; ++i) {
          if (updatedSuggestions[action.payload.text].data.sequences.indexOf(data['sequences'][i]) === -1 &&
            action.payload.text !== data['sequences'][i]) {
            updatedSuggestions[action.payload.text].data.sequences.push(data['sequences'][i])
            updatedSuggestions[action.payload.text].data.sequences_scores.push(data['sequences_scores'][i] || 0)
          }
        }
      }

      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          nnSuggestions: updatedSuggestions
        }
      }
    case 'FETCH_NN_SUGGESTION_REQUEST':
      nnSuggestions[action.payload.text] = {}
      nnSuggestions[action.payload.text]['loading'] = true
      nnSuggestions[action.payload.text]['error'] = null
      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          nnSuggestions: nnSuggestions,
        },
      }
    case 'FETCH_NN_SUGGESTION_FAILURE':
      nnSuggestions[action.payload.text]['loading'] = false
      nnSuggestions[action.payload.text]['error'] = action.payload.err
      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          nnSuggestions: nnSuggestions,
        },
      }

    case 'FETCH_LANGUAGE_TOOL_SUCCESS':
      return {
        ...state.analyseData,
        result: {
          ...state.analyseData.result,
          resultData: {
            ...state.analyseData.result.resultData,
            languageTool: action.payload,
          },
        },
      }
    case 'FETCH_LANGUAGE_TOOL_FAILURE':
    case 'FETCH_LANGUAGE_TOOL_REQUEST':
      return {
        ...state.analyseData,
        result: {
          ...state.analyseData.result,
          resultData: {
            ...state.analyseData.result.resultData,
            languageTool: {},
          },
        },
      }
    case 'ANALYSE_SET_TERMCAT_TEXTTONE':
      return {
        ...state.analyseData,
        termCatTexttone: action.payload,
      }
    case 'FETCH_POPOVER_SUGGESTION_SUCCESS':
      let newPopups = [...state.analyseData.popover.popups]
      newPopups[action.payload.id].data.suggestion = action.payload.suggestion

      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          popups: newPopups,
        },
      }
    case 'ANALYSE_SET_BODY_BORDER_SHOW':
      return {
        ...state.analyseData,
        bodyBorderShow: action.payload,
      }

    case 'ANALYSE_SET_AI_MODE':
      return {
        ...state.analyseData,
        aiMode: action.payload,
      }
    case 'ANALYSE_SET_AI_DATA':
      return {
        ...state.analyseData,
        aiData: action.payload,
      }

    case 'ANALYSE_SET_LT_OFFSET':
      return {
        ...state.analyseData,
        ltOffset: action.payload,
      }

    case 'ANALYSE_SET_AUTO_TEXT_LANGUAGE':
      return {
        ...state.analyseData,
        autoTextLanguage: action.payload,
      }

    case 'ANALYSE_SET_TEXT_LANGUAGE':
      return {
        ...state.analyseData,
        textLanguage: action.payload,
      }

    case 'ANALYSE_SET_IGNORE_LIST':
      return {
        ...state.analyseData,
        ignoreList: action.payload,
      }

    case 'ANALYSE_CLEAR_IGNORE_LIST':
      return {
        ...state.analyseData,
        ignoreList: defaultState.ignoreList,
      }

    case 'ANALYSE_SET_USE_BENCHMARK':
      return {
        ...state.analyseData,
        useBenchmark: action.payload,
      }

    case 'ANALYSE_SET_ENABLED_BENCHMARK':
      return {
        ...state.analyseData,
        enabledBenchmarks: action.payload,
      }

    case 'ANALYSE_SET_TOP_ACCORDION':
      return {
        ...state.analyseData,
        topAccordionOpen: action.payload,
      }

    case 'ANALYSE_SET_MODAL_ACCORDION':
      return {
        ...state.analyseData,
        modalAccordionOpen: action.payload,
      }

    case 'ANALYSE_SET_FILTER':
      return {
        ...state.analyseData,
        filter: action.payload,
      }

    case 'ANALYSE_CLEAR_FILTER':
      return {
        ...state.analyseData,
        filter: defaultState.filter,
      }

    case 'ANALYSE_SET_TEXT':
      return {
        ...state.analyseData,
        text: action.payload,
      }

    case 'ANALYSE_SET_OLD_TEXT':
      return {
        ...state.analyseData,
        oldText: action.payload,
      }
    case 'ANALYSE_SET_TRANSLATED_TEXT':
      return {
        ...state.analyseData,
        translatedText: action.payload,
      }

    case 'ANALYSE_SET_LOCAL_RESULT':
      return {
        ...state.analyseData,
        result: {
          ...state.analyseData.result,
          localAnalyseResultData: action.payload.localAnalyseResultData,
        },
      }

    case 'ANALYSE_SET_AI_LOCAL_RESULT':
      return {
        ...state.analyseData,
        result: {
          ...state.analyseData.result,
          aiLocalAnalyseResultData: action.payload.aiLocalAnalyseResultData,
        },
      }

    case 'ANALYSE_SET_LANGUAGE_LEVEL_DATA_WITH_CHILDREN':
      return {
        ...state.analyseData,
        result: {
          ...state.analyseData.result,
          languageLevelDataWithChildren: action.payload || {},
        },
      }

    case 'ANALYSE_SET_RESULT':
      return {
        ...state.analyseData,
        result: {
          ...state.analyseData.result,
          resultData: action.payload.resultData,
          languageLevelDataWithChildren: action.payload.resultData?.dataLanguageLevel || {},
          localAnalyseResultData: action.payload.resultData,
          resultTemplate: action.payload.resultTemplate,
          benchmark: action.payload.benchmark,
        },
      }
    case 'ANALYSE_CLEAR_RESULT':
      return {
        ...state.analyseData,
        result: defaultState.result,
      }

    case 'ANALYSE_SET_SANITIZE_STATE':
      return {
        ...state.analyseData,
        sanitize: {
          ...state.analyseData.sanitize,
          ...action.payload,
        },
      }

    case 'ANALYSE_CLEAR_SANITIZE_STATE':
      return {
        ...state.analyseData,
        sanitize: defaultState.sanitize,
      }

    case 'ANALYSE_CLEAR_ALL':
      return defaultState

    case 'ANALYSE_SET_POPUPS':
      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          popups: action.payload,
        },
      }
    case 'ANALYSE_SET_CURRENT_POPUP':
      return {
        ...state.analyseData,
        popover: {
          ...state.analyseData.popover,
          currentPopup: action.payload,
        },
      }
    case 'ANALYSE_CLEAR_POPOVERS':
      return {
        ...state.analyseData,
        popover: defaultState.popover,
      }
    case 'ANALYSE_SET_ALLOWLISTTEXT':
      return {
        ...state.analyseData,
        allowListText: action.payload,
      }
    case 'ANALYSE_SET_POPUPDATA':
      return {
        ...state.analyseData,
        popUpData: action.payload,
      }
    case 'ANALYSE_SET_PROGRESS_BAR':
      return {
        ...state.analyseData,
        analyseProgressBar: action.payload,
      }
    case 'ANALYSE_SET_FILE_NAME':
      return {
        ...state.analyseData,
        fileName: action.payload,
      }
    case 'ANALYSE_SET_ACCORDION_ITEMS_WITH_CELLS':
      if (state.analyseData.accordionItemsWithCells.includes(action.payload)) {
        return state.analyseData
      } else {
        return {
          ...state.analyseData,
          accordionItemsWithCells: [...state.analyseData.accordionItemsWithCells, action.payload],
        }
      }

    case 'ANALYSE_CLEAR_ACCORDION_ITEMS_WITH_CELLS':
      return {
        ...state.analyseData,
        accordionItemsWithCells: defaultState.accordionItemsWithCells,
      }

    default:
      return state.analyseData
  }
}

export default updateAnalyseData